import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
  selectCurrentFlowId,
  selectHasInProgressUpload,
} from "slices/workspace/selectors";

const getCsrfToken = () => {
  const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : "";
};

const useUploadUnloadGuard = () => {
  const hasInProgressUpload = useSelector(selectHasInProgressUpload);
  const currentFlowId = useSelector(selectCurrentFlowId);
  const flowIdRef = useRef(currentFlowId);

  useEffect(() => {
    flowIdRef.current = currentFlowId;
  }, [currentFlowId]);

  useEffect(() => {
    if (!hasInProgressUpload || !currentFlowId) {
      return;
    }

    const handleBeforeUnload = (event) => {
      event.preventDefault();
    };

    const handlePageHide = () => {
      if (!flowIdRef.current) {
        return;
      }
      const params = new URLSearchParams();
      params.append("flowId", flowIdRef.current);
      params.append("_csrf", getCsrfToken());
      navigator.sendBeacon(
        "/document/queue/cancel-uploading-beacon",
        params
      );
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("pagehide", handlePageHide);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("pagehide", handlePageHide);
    };
  }, [hasInProgressUpload, currentFlowId]);
};

export default useUploadUnloadGuard;
